









import { Component, Vue } from "vue-property-decorator";
import { Client, Event } from "@leancloud/play";
import Login from "./components/Login.vue";
import Lobby from "./components/Lobby.vue";
import Game from "./components/Game.vue";
import { errorHandler } from "./utils";

@Component({
  components: {
    Login,
    Lobby,
    Game
  }
})
export default class App extends Vue {
  status = "LOGIN";
  client?: Client;

  private onLogin(client: Client) {
    this.client = client;
    this.status = "LOBBY";
  }
  private onRoomJoined() {
    this.status = "GAME";
  }
  private onRoomLeft() {
    this.status = "LOBBY";
  }
}
